import { firebase } from '@firebase/app'
import config from './config'
import '@firebase/auth'
import '@firebase/messaging'

firebase.initializeApp(config)
